module.exports = __webpack_public_path__ + "img/calendar-line.c8b053d1.svg";